
  var ALGOLIA_INSIGHTS_SRC =
  "https://cdn.jsdelivr.net/npm/search-insights@2.16.3/dist/search-insights.min.js";
  !function(e,a,t,n,s,i,c)
  {
    ((e.AlgoliaAnalyticsObject = s),
    (e[s] =
      e[s] ||
      function () {
        (e[s].queue = e[s].queue || []).push(arguments);
      }),
    (e[s].version = (n.match(/@([^\/]+)\/?/) || [])[1]),
    (i = a.createElement(t)),
    (c = a.getElementsByTagName(t)[0]),
    (i.async = 1),
    (i.src = n),
    c.parentNode.insertBefore(i, c))
  }
  (window,document,"script",ALGOLIA_INSIGHTS_SRC,"aa");


  const algoliaAppId = document.querySelector('meta[name="algolia-app-id"]')?.content;
  const algoliaApiKey = document.querySelector('meta[name="algolia-api-key"]')?.content;

document.addEventListener("DOMContentLoaded", function () {
      const algoliaAppId = document.querySelector('meta[name="algolia-app-id"]')?.content;
      const algoliaApiKey = document.querySelector('meta[name="algolia-api-key"]')?.content;

  
    const algoliaIndexName = 'shopify_products';
    // Initialize Algolia client
    const client = algoliasearch(algoliaAppId, algoliaApiKey);
    const index = client.initIndex(algoliaIndexName);
    console.log("Algolia client and index initialized ====", client, index);
    // Check Algolia connection
    index.search('', { hitsPerPage: 1 }).then(({ hits }) => {
      if (hits.length > 0) {
      } else {
      }
    })
  });


  window.aa = window.aa || function () {
    (window.aa.queue = window.aa.queue || []).push(arguments);
  };

  aa('init', {
    appId: algoliaAppId,
    apiKey: algoliaApiKey // This must be an Insights key
  });

/*********** CODE TO SEND THE VIEW ANALYTICS IN ALGOLIA WITH AND WITHOUT QUERYID */
document.addEventListener("DOMContentLoaded", function () {
  console.log("loaded");
   const client = algoliasearch(algoliaAppId, algoliaApiKey);
  const index = client.initIndex('shopify_products');

  const searchInput = document.getElementById("search-header");
  console.log("searchInput====", searchInput);
 


    // Only run this on mobile view when search icon is clicked
const searchIcon = document.querySelector('.searchIcon'); // update selector if needed
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)    || (window.innerWidth <= 1024);

    
    if (window.location.href.includes('/collections/')) {
  // // alert("location found on mobile or desktop");

  // Simple mobile detection
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)    || (window.innerWidth <= 1024);
  const delay = isMobile ? 3500 : 1500;

  setTimeout(() => {
    const currentURL = window.location.href;
    const collectionHandle = currentURL.split('/collections/')[1]?.split('?')[0].split('/')[0];
    console.log("Collection Handle:", collectionHandle);

    const productCards = document.querySelectorAll('.product-item');
    console.log("Detected product cards:", productCards);

    if (productCards.length > 0) {
      const viewedItems = [];

      productCards.forEach((item) => {
        if (viewedItems.length >= 19) return;

        const ID = item.getAttribute('data-algolia-object-id');

        if (ID) {
          viewedItems.push({ ID });
        }
      });

      if (viewedItems.length > 0 && collectionHandle) {
        const allIDs = viewedItems.map(item => item.ID);

        // ✅ Construct valid filters array with collectionHandle and source
        const filters = [
          `collection:${collectionHandle}`,
          `source:Collection`
        ];

        const displayFilters = filters.map(f => f.replace(':', ': '));
        console.log("Pretty filters for logging/UI:", displayFilters);

        window.aa('viewedFilters', {
          index: 'shopify_products',
          eventName: 'Without Search Product Viewed',
          filters: displayFilters,
          ID: allIDs
        });

        console.log(`Sent filter view event for collection: ${collectionHandle} with IDs:`, allIDs);
      }
    }
  }, delay);
}


else if (window.location.href.includes('/search?q=')) {
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)    || (window.innerWidth <= 1024);
  const delay = isMobile ? 3500 : 2500; // Adjust delay as needed

  setTimeout(() => {
    const spanEl = document.querySelector('.searchResultHeaderPage span');
    if (spanEl) {
      let spanText = spanEl.textContent.trim();
      spanText = spanText.replace(/^["']|["']$/g, ''); // Remove quotes

      // Use different selectors for mobile vs desktop
      const productCards = isMobile
        ? document.querySelectorAll('.recommended.algoliasearchresults')
        : document.querySelectorAll('.product-item');

      console.log(`🟡 Detected product cards (${isMobile ? 'mobile' : 'desktop'}):`, productCards.length);

      if (productCards.length > 0) {
        const productIDs = [];
        const queryID = localStorage.getItem('algolia_query_id');

        productCards.forEach((item, index) => {
          localStorage.getItem('algolia_query_id', queryID);
          item.setAttribute("data-algolia-query-id", queryID);
          const ID = item.getAttribute('data-algolia-object-id');
          if (ID) {
            productIDs.push(ID);
            console.log(`🟢 Product ${index + 1} - ID: ${ID}`);
          }
        });

        const filters = [
          `searchTerm:${spanText}`,
          `source:Search`
        ];

        window.aa('viewedFilters', {
          index: 'shopify_products',
          eventName: 'PRODUCT VIEW VIA ALGOLIA SEARCH (FILTERS)',
          filters: filters,
          ID: productIDs,
          queryID: queryID,
        });

        console.log(`📡 Sent viewedFilters event with filters: ${filters.join(', ')}`);
        console.log(`🧾 Related objectIDs (not sent):`, productIDs);
      }
    }
  }, delay);
}
  

else if (searchInput) {
  let debounceTimeout;
  let latestSearchTerm = '';
  let triggeredByPopularClick = false;

  searchInput.addEventListener("input", function (event) {
    triggeredByPopularClick = false; // Reset this flag on normal typing
    clearTimeout(debounceTimeout);

    // Show loader when user types
    const container = document.querySelector('.completesearchdiv.container');
    container?.classList.add('loading');

    debounceTimeout = setTimeout(() => {
      const inputValue = event.target.value.trim();
      latestSearchTerm = inputValue || "";
      console.log("🔍 User stopped typing, search term:", latestSearchTerm || "(empty)");

      handleSearchEvent();
    }, 3500);
  });

  searchInput.addEventListener('click', function () {
    triggeredByPopularClick = false;
    localStorage.removeItem('algolia_query_id');
    console.log("🧹 Cleared queryID from localStorage due to normal input click");

    if (searchInput.value.trim() === '') {
      triggeredByPopularClick = false;
      localStorage.removeItem('algolia_query_id');
      console.log("🧹 Cleared queryID from localStorage because search input is blank");
    }

    // Show loader on click
    const container = document.querySelector('.completesearchdiv.container');
    container?.classList.add('loading');

    handleSearchEvent();
  });

  // Handle click on popular searches
  document.addEventListener('click', function (event) {
    const popularLi = event.target.closest('li.popularsearches.algoliasearchresults');
    if (popularLi) {
      triggeredByPopularClick = true;
      latestSearchTerm = popularLi.getAttribute('data-product-title') || '';
      console.log("🔥 Popular search clicked:", latestSearchTerm);

      // Show loader for popular search click
      const container = document.querySelector('.completesearchdiv.container');
      container?.classList.add('loading');

      handleSearchEvent();
    }
  });

function handleSearchEvent() {
  setTimeout(() => {
    const resultItems = document.querySelectorAll('.searchResultsheader li.algoliasearchresults');
    const viewedItems = [];

    resultItems.forEach((item, index) => {
      if (viewedItems.length >= 3) return;

      const ID = item.getAttribute('data-algolia-object-id');
      const variantId = item.getAttribute('data-variant-id');
      const title = item.getAttribute('data-product-title');

      if (item && ID) {
        if (latestSearchTerm.trim() !== "" || triggeredByPopularClick) {
          item.setAttribute('search-term', latestSearchTerm);
        }

        // ✅ FIXED: include ID in viewedItems
        viewedItems.push({ ID, variantId, title, source: "Search" });

        // ✅ Attach click listener here
        if (!item.hasAttribute("data-click-bound")) {
          item.setAttribute("data-click-bound", "true");
          const position = index + 1;
          item.setAttribute("data-algolia-position", position);

          item.addEventListener("click", () => {
            const currentQueryID = localStorage.getItem('algolia_query_id');
            aa('clickedObjectIDsAfterSearch', {
              index: 'shopify_products',
              eventName: 'Clicked Search Result Query',
              objectIDs: [variantId],
              positions: [position],
              queryID: currentQueryID,
              ProductTitle: title,
              Source: 'Search Suggestions',
              ID: ID,
              SearchTerm: latestSearchTerm
            });
            console.log("🖱️ Tracked click:", { ID, title, position, queryID: currentQueryID });
          });
        }
      }
    });

    const container = document.querySelector('.completesearchdiv.container');

    // ✅ Remove loader FIRST
    container?.classList.remove('loading');

    // ✅ THEN send view analytics immediately after loader stops
    if (viewedItems.length > 0 && window.aa) {
      const searchFilterValue = latestSearchTerm.trim() === "" ? "<blank>" : latestSearchTerm.trim();
      const filters = [
        `source:Search`,
        `searchTerm:${searchFilterValue}`
      ];

      const shouldSendQueryID = latestSearchTerm.trim() !== "" || triggeredByPopularClick;
      const storedQueryID = shouldSendQueryID ? localStorage.getItem('algolia_query_id') : undefined;

      const payload = {
        index: 'shopify_products',
        eventName: 'Search Results Viewed Desktop',
        filters: filters,
        ID: viewedItems.map(item => item.ID),
      };

      if (shouldSendQueryID) {
        payload.queryID = storedQueryID;
      }

      window.aa('viewedFilters', payload);
      console.log("📤 Sent view after loader stopped:", payload);
    }
  }, 300); // Small timeout to wait for DOM update
}

} 
  
else if (searchIcon && isMobile) {
  searchIcon.addEventListener('click', function () {
    console.log("📱🔍 Mobile search icon clicked");

    setTimeout(() => {
      const resultItems = document.querySelectorAll('.searchResultsheader li.recommended.algoliasearchresults');
      const viewedItems = [];

      resultItems.forEach((item, index) => {
        if (viewedItems.length >= 5) return;

        const ID = item.getAttribute('data-algolia-object-id');
        const title = item.getAttribute('data-product-title');
        const queryID = localStorage.getItem('algolia_query_id');

        console.log("this is the algolia object id====",ID, title, queryID);

        if (item && ID) {
          viewedItems.push({
            ID,
            title,
            source: "Search"
          });

          item.setAttribute('search-term', 'Blank');
          item.setAttribute('data-algolia-query-id', queryID);
        }
      });

      if (viewedItems.length > 0 && window.aa) {
        const filters = [
          `source:Search`,
          `searchTerm:blank`
        ];

        const payload = {
          index: 'shopify_products',
          eventName: 'Mobile Search Icon Click - Viewed Filters',
          filters: filters,
          ID: viewedItems.map(item => item.ID)
        };

        window.aa('viewedFilters', payload);
        console.log("📡 Sent viewedFilters from mobile search icon click:", payload);
      }
    }, 300); // short delay to allow DOM to update
  });
}
 else{
     console.log("NOTHING FOUND");
  }
});

 

/********************** START MOBILE VIEW TRACKING EVENTS WITH SEARCH TERM ***********************/
function handleSearchEventMobile(latestSearchTerm, triggeredByPopularClick) {
  const client = algoliasearch(algoliaAppId, algoliaApiKey);
  const index = client.initIndex('shopify_products');

  setTimeout(() => {
    const container = document.querySelector('.completesearchdiv.container');
    const searchHeader = document.querySelector('.searchResultsheader');
    if (!container || !searchHeader) {
      console.warn("⛔ Skipped tracking: Not on search page.");
      return;
    }

    const resultItems = document.querySelectorAll('.searchResultsheader li.recommended.algoliasearchresults');
    const viewedItems = [];

    resultItems.forEach((item, index) => {
      if (viewedItems.length >= 5) return;

      const ID = item.getAttribute('data-algolia-object-id');
      const title = item.getAttribute('data-product-title');

      if (item && ID) {
        if (latestSearchTerm.trim() !== "" || triggeredByPopularClick) {
          item.setAttribute('search-term', latestSearchTerm);
          console.log(`✅ Updated item ${index} with queryID and search term: ${latestSearchTerm || "(empty)"}`);
        }

        viewedItems.push({
          ID,
          title,
          source: "Search",
        });
      }
    });

    // ✅ FIRST remove the loader
    container.classList.remove('loading');

    // ✅ THEN send view analytics after loader is gone
    if (viewedItems.length > 0 && window.aa) {
      const searchFilterValue = latestSearchTerm.trim() === "" ? "<blank>" : latestSearchTerm.trim();
      const filters = [
        `source:Search`,
        `searchTerm:${searchFilterValue}`
      ];

      const shouldSendQueryID = latestSearchTerm.trim() !== "" || triggeredByPopularClick;
      const storedQueryID = shouldSendQueryID ? localStorage.getItem('algolia_query_id') : undefined;

      const payload = {
        index: 'shopify_products',
        eventName: 'Search Results Viewed Mobile',
        filters: filters,
        ID: viewedItems.map(item => item.ID),
      };

      if (shouldSendQueryID) {
        payload.queryID = storedQueryID;
      }

      window.aa('viewedFilters', payload);
      console.log(`📤 Sent viewedFilters event with filters:`, filters, shouldSendQueryID ? `and queryID: ${storedQueryID}` : "(no queryID)");
    }
  }, 300);
}


document.addEventListener('DOMContentLoaded', function () {
  const searchIcon = document.querySelector('.searchIcon');

  if (searchIcon) {
    searchIcon.addEventListener('click', function () {
      setTimeout(() => {
        const mobileInput = document.querySelector('.searchResultHeaderPage');

        if (mobileInput) {
          let debounceTimeout;
          let latestSearchTerm = '';
          let triggeredByPopularClick = false;

          mobileInput.addEventListener("input", function (event) {
            triggeredByPopularClick = false;
            clearTimeout(debounceTimeout);

            const container = document.querySelector('.completesearchdiv.container');
            container?.classList.add('loading');

            debounceTimeout = setTimeout(() => {
              const inputValue = event.target.value.trim();
              latestSearchTerm = inputValue || "";
              console.log("📱🔍 Mobile user stopped typing, search term:", latestSearchTerm || "(empty)");

              handleSearchEventMobile(latestSearchTerm, triggeredByPopularClick);
            }, 2500);
          });

          mobileInput.addEventListener('click', function () {
            triggeredByPopularClick = false;
            localStorage.removeItem('algolia_query_id');
            console.log("📱🧹 Cleared queryID from localStorage due to mobile input click");

            const container = document.querySelector('.completesearchdiv.container');
            container?.classList.add('loading');

            handleSearchEventMobile(latestSearchTerm, triggeredByPopularClick);
          });

          // document.addEventListener('click', function (event) {
          //   const popularLi = event.target.closest('li.recommended.algoliasearchresults');
          //   if (popularLi) {
          //     triggeredByPopularClick = true;
          //     latestSearchTerm = popularLi.getAttribute('data-product-title') || '';
          //     console.log("📱🔥 Mobile popular search clicked:", latestSearchTerm);

          //     const container = document.querySelector('.completesearchdiv.container');
          //     container?.classList.add('loading');

          //     handleSearchEventMobile(latestSearchTerm, triggeredByPopularClick);
          //   }
          // });
        }
      }, 300);
    });
  }
});
/********************** END MOBILE VIEW TRACKING EVENTS WITH SEARCH TERM ***********************/


/*************** PRODUCT CLICK COUNT FROM SEARCH ***********/
document.addEventListener("DOMContentLoaded", function () {
  const client = algoliasearch(algoliaAppId, algoliaApiKey);
  const index = client.initIndex('shopify_products');

    // === CASE 1: Handle .recommended.algoliasearchresults after a delay ===
    setTimeout(() => {
      document.querySelectorAll("li.recommended.algoliasearchresults").forEach((productEl, idx) => {
        const objectID = productEl.getAttribute("data-variant-id");
        const ProductID = productEl.getAttribute("data-algolia-object-id");
        const productTitle = productEl.getAttribute("data-product-title");
        const position = idx + 1;

        productEl.setAttribute("data-algolia-position", position);

        if (productEl.getAttribute("data-click-bound") === "true") return;
        productEl.setAttribute("data-click-bound", "true");

        productEl.addEventListener("click", () => {
          alert("product Item clicked");
          aa('clickedObjectIDs', {
            
            index: 'shopify_products',
            eventName: 'Clicked Recommended Product',
            objectIDs: [objectID],
            ProductTitle: productTitle,
            ID:ProductID,
            Source: 'Search Recommended Products'
          });
          console.log("✅ Clicked Recommended Product:", { objectID, position, productTitle, currentQueryID });
        });
      });
    }, 1500);


// === CASE 2: Handle .recommended.algoliasearchresults after a delay ===
const searchInput = document.getElementById("search-header");
let typingTimeout;
let observerStarted = false;
let pollingStarted = false;
let pollingInterval;

if (!searchInput) {
  // alert("❌ search-header input not found");
  console.warn("❌ search-header input not found");
} else {
  console.log("✅ search-header input found");

  searchInput.addEventListener("input", () => {

    const inputValue = event.target.value.trim();
   latestSearchTerm = inputValue || ""; // Set to blank if empty
   console.log("🔍 User stopped typing, search term:", latestSearchTerm || "(empty)");
    clearTimeout(typingTimeout);

    typingTimeout = setTimeout(() => {
      // alert("🛑 Typing stopped, checking for .searchResultsheader...");

      const resultsContainer = document.querySelector(".searchResultsheader");
      if (!resultsContainer) {
        // alert("❌ .searchResultsheader not found after typing");
        console.warn("❌ .searchResultsheader not found after typing");
        return;
      }

      console.log("✅ .searchResultsheader found");

      // ✅ Mutation Observer Setup
      if (!observerStarted) {
        observerStarted = true;
        // alert("👁️ Setting up MutationObserver on .searchResultsheader");

        const observer = new MutationObserver(() => {
          // alert("🔄 MutationObserver triggered - DOM changed inside .searchResultsheader");
          bindClickEvents();
        });

        observer.observe(resultsContainer, { childList: true, subtree: true });
        // alert("✅ MutationObserver is now observing .searchResultsheader");
      }

      // ✅ Polling Fallback Setup
      if (!pollingStarted) {
        pollingStarted = true;
        // alert("⏳ Starting polling fallback to check for product elements...");

        pollingInterval = setInterval(() => {
          const productEls = document.querySelectorAll("li.algoliasearchresults");
          // alert("PRODUCT FOUND");
          if (productEls.length > 0) {
            // alert(`📦 Found ${productEls.length} product(s) via polling`);
            bindClickEvents();
            clearInterval(pollingInterval); // Stop polling after success
          } else {
            // alert("🔁 Polling: No products yet...");
          }
        }, 1500); // Check every 1.5 seconds
      }
    }, 2500); // 1 second debounce after typing
  });
}

// ✅ Function to bind click events to product elements
function bindClickEvents() {
  // alert("startted running");
  const productEls = document.querySelectorAll("li.algoliasearchresults");

  if (productEls.length === 0) {
    // alert("❌ No .algoliasearchresults found.");
    return;
  }

  productEls.forEach((productEl, index) => {
    if (productEl.getAttribute("data-click-bound") === "true") {
      // alert(`⏩ Skipping already-bound product at index ${index}`);
      return;
    }

    const objectID = productEl.getAttribute("data-variant-id");
    const productId = productEl.getAttribute("data-algolia-object-id");
    const productTitle = productEl.getAttribute("data-product-title") || "Unnamed Product";
    const position = index + 1;

    // alert(`✅ Binding click for: ${productTitle}, position: ${position}`);

    productEl.setAttribute("data-click-bound", "true");
    productEl.setAttribute("data-algolia-position", position);

         const currentQueryID = localStorage.getItem('algolia_query_id');
          console.log("🚨 Query ID on click developer data:", currentQueryID);

    productEl.addEventListener("click", () => {
      // alert(`🖱️ Clicked: ${productTitle}, position: ${position}`);
      aa('clickedObjectIDsAfterSearch', {
        index: 'shopify_products',
        eventName: 'Clicked Search Result',
        objectIDs: [objectID],
        positions: [position],
        queryID: currentQueryID,
        ProductTitle: productTitle,
        Source: 'Search Suggestions',
        ID:productId,
        SearchTerm: latestSearchTerm
      });
      console.log("✅ Clicked Search Result:", { objectID, position, productTitle, queryID });
    });
  });
}
});


/*************** PRODUCT CLICK COUNT FROM SEARCH MOBILE VIEW ***********/
document.addEventListener("DOMContentLoaded", function () {
  const searchIcon = document.querySelector('.searchIcon'); // Replace with your actual selector
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)    || (window.innerWidth <= 1024);
  if (searchIcon && isMobile) {
    searchIcon.addEventListener('click', function () {
      console.log("📱🔍 Mobile search icon clicked");

      setTimeout(() => {
        // alert("📥 Timeout after mobile search icon click");

        document.querySelectorAll("li.recommended.algoliasearchresults").forEach((productEl, idx) => {
          console.log("🔄 Found product element:", productEl);

          const objectID = productEl.getAttribute("data-variant-id");
          const ProductID = productEl.getAttribute("data-algolia-object-id");
          const productTitle = productEl.getAttribute("data-product-title");
          const position = idx + 1;

          productEl.setAttribute("data-algolia-position", position);

          if (productEl.getAttribute("data-click-bound") === "true") return;
          productEl.setAttribute("data-click-bound", "true");

          productEl.addEventListener("click", () => {
            // alert("🟢 Product item clicked");

            window.aa('clickedObjectIDs', {
              index: 'shopify_products',
              eventName: 'Clicked Recommended Product',
              objectIDs: [objectID],
              ProductTitle: productTitle,
              ID: ProductID,
              Source: 'Search Recommended Products',
            });

            console.log("✅ Tracked click:", {
              objectID, position, productTitle, currentQueryID
            });

            // alert("✅ Tracking finished");
          });
        });
      }, 1500); // Allow DOM to update
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const searchIcon = document.querySelector('.searchIcon');
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)    || (window.innerWidth <= 1024);

  if (searchIcon && isMobile) {
    searchIcon.addEventListener('click', function () {
      console.log("📱🔍 Mobile search icon clicked");

      setTimeout(() => {
        const searchInput = document.querySelector('#search-header');
        if (!searchInput) return;

        let debounceTimeout;
          searchInput.addEventListener('keyup', () => {
            clearTimeout(debounceTimeout);

            debounceTimeout = setTimeout(() => {
              const value = searchInput.value.trim();
              if (value !== "") {
                console.log("🔍 User stopped typing, input value:", value);
                setTimeout(() => {
                  attachProductTracking();
                }, 800); // delay for UI rendering
              }
            }, 2000); // 2 seconds of inactivity
          });
      }, 500); // allow UI to open
    });
  }

function attachProductTracking() {
  // alert("sjdgcjhsdfjh");

  document.querySelectorAll("li.recommended.algoliasearchresults").forEach((productEl, idx) => {
    console.log("🔄 Found product element:", productEl, idx);

    const objectID = productEl.getAttribute("data-variant-id");
    const ProductID = productEl.getAttribute("data-algolia-object-id");
    const productTitle = productEl.getAttribute("data-product-title");
    const position = idx + 1; // Use directly

    productEl.setAttribute("data-algolia-positions", position);

    if (productEl.getAttribute("data-click-bound") === "true") return;
    productEl.setAttribute("data-click-bound", "true");

    productEl.addEventListener("click", () => {
      console.log("🟢 Product item clicked from search input");

      const currentQueryID = localStorage.getItem('algolia_query_id');
      console.log("🚨 Query ID on click:", currentQueryID);

      window.aa('clickedObjectIDs', {
        index: 'shopify_products',
        eventName: 'Clicked Recommended Product (Search Input)',
        objectIDs: [objectID],
        positions: [position], // ✅ Correct key and array value
        queryID: currentQueryID,
        custom: { // ✅ Extra data belongs in `custom`
          ProductTitle: productTitle,
          ID: ProductID,
          Source: 'Search Results Header'
        }
      });

      console.log("✅ Tracked click from search input:", {
        objectID, position, productTitle, currentQueryID
      });
    });
  });
}

});



/*************** PRODUCT CLICK COUNT FROM NORMAL COLLECTION WITH PRODUCT ITEM***********/
document.addEventListener("DOMContentLoaded", function () {
  const client = algoliasearch(algoliaAppId, algoliaApiKey);
  const index = client.initIndex('shopify_products');
    setTimeout(() => {
      const HeaderResults = document.querySelector(".searchResultHeaderPage");
      console.log("907979887878", HeaderResults);
      const spanElement = document.querySelector('.searchResultHeaderPage span');
      let spanText = null;

      if (spanElement && typeof spanElement.textContent === 'string') {
        spanText = spanElement.textContent.trim().replace(/^['"]|['"]$/g, '');
      }

      if (HeaderResults && spanText) {
        document.querySelectorAll(".product-item").forEach((productEl, idx) => {
          productEl.setAttribute("product-clicked-source", "Search");
          productEl.setAttribute("product-clicked-collection", spanText);
          
          const objectID = productEl.getAttribute("data-variant-id");
          const ProductID = productEl.getAttribute("data-algolia-object-id");
          const productTitle = productEl.getAttribute("data-product-title");
          const position = idx + 1;
          console.log

          productEl.setAttribute("data-algolia-position", position);
          const source = productEl.getAttribute("product-clicked-source");
          const SearchTerm = productEl.getAttribute("product-clicked-collection");

          // Avoid rebinding the click event
          if (productEl.getAttribute("data-click-bound") === "true") return;
          productEl.setAttribute("data-click-bound", "true");

           const storedQueryID = localStorage.getItem('algolia_query_id');
          console.log("storedQueryIDstoredQueryID",storedQueryID);

          productEl.addEventListener("click", () => {
            aa('clickedObjectIDsAfterSearch', {
              index: 'shopify_products',
              eventName: 'PRODUCT CLICK VIA ALGOLIA SERACH COLLECTIONS PAGE',
              objectIDs: [objectID],
              positions: [position],
              queryID: storedQueryID,
              Producttitle: productTitle,
              ID:ProductID,
              source: source,
              SearchTerm: SearchTerm
            });
          });
        });
        } else {
        // alert("Entered else part 😉");
          const currentURL = window.location.href;
        const collectionHandle = currentURL.split('/collections/')[1]?.split('?')[0].split('/')[0];
        console.log("Collection Handle:", collectionHandle);
        
        document.querySelectorAll(".product-item").forEach((productEl, idx) => {
          productEl.setAttribute("product-clicked-source", "Search");
          productEl.setAttribute("product-clicked-collection", collectionHandle);
        
          const objectID = productEl.getAttribute("data-variant-id");
          const productId = productEl.getAttribute("data-algolia-object-id");
          const productTitle = productEl.getAttribute("data-product-title");
          const position = idx;
        
          productEl.setAttribute("data-algolia-position", position);
        
          if (productEl.getAttribute("data-click-bound") === "true") return;
          productEl.setAttribute("data-click-bound", "true");
        
          productEl.addEventListener("click", () => {
            aa('clickedObjectIDs', {
              index: 'shopify_products',
              eventName: 'COLLECTION PRODUCT CLICK WITHOUT QUERY ID',
              objectIDs: [objectID],
              userData: {
                ID: productId,
                position: position,
                productTitle: productTitle,
                source: "collection",
                collection: collectionHandle
              }
            });
          });
        });

      }

    }, 1500);
});

  /*************** ADD TO CART COUNT FROM PRODUCT PAGE***********/
document.addEventListener("DOMContentLoaded", function () {
  const referrer = document.referrer;
  console.log("🔙 Referrer URL:", referrer);

  const cameFromCollection = referrer.includes('/collections/');

  const client = algoliasearch(algoliaAppId, algoliaApiKey);
  const index = client.initIndex('shopify_products');

    const button = document.querySelector('.cta-button-color-settings.test');
   console.log("jdgcjhsdgjhcgsdhgcjhsdgcjhgdh=====",button);
    if (button) {
      button.addEventListener('click', function () {
        const objectID = button.getAttribute("data-variant-id");
        const posAttr = button.getAttribute("data-algolia-position");
        const position = posAttr && !isNaN(posAttr) ? parseInt(posAttr) : undefined;
        const productTitle = button.getAttribute("product-title");
        const productId = button.getAttribute("data-algolia-object-id");
        const productVariantName = button.getAttribute("data-variant-name");
        const storedQueryID = localStorage.getItem('algolia_query_id');

        console.log("🛒 Add to Cart tracked for:", objectID, "at position:", position, "queryID:", storedQueryID);

        const payload = {
          index: 'shopify_products',
          eventName: 'Added to Cart',
          objectIDs: [objectID],
          productTitle: productTitle,
          ID: productId,
          VariantName: productVariantName,
          referrer: referrer || 'Direct'
        };

        // Only send queryID if not from a collection page
        if (!cameFromCollection && storedQueryID) {
          payload.queryID = storedQueryID;
        }

        // Only send position if queryID is valid (otherwise it won't make sense to Algolia)
        if (!cameFromCollection && storedQueryID && position !== undefined) {
          payload.positions = [position];
        }

        console.log("📦 Sending payload to Algolia Insights:", payload);
        aa('convertedObjectIDsAfterSearch', payload);
      });
    }
});


/*************** ADD TO CART COUNT FOR COLLECTION PAGE ***********/
  document.addEventListener("DOMContentLoaded", function () {
  const client = algoliasearch(algoliaAppId, algoliaApiKey);
  const index = client.initIndex('shopify_products');
 
    const button = document.querySelector('.collectionCart');
    console.log("collectionCartcollectionCartcollectionCartcollectionCart", button);
    
  setTimeout(() => {
    if (button) {
      console.log("REFHVNB=====test", button);
      button.setAttribute('data-algolia-query-id', queryID);
 
      button.addEventListener('click', function () {
        const objectID = button.getAttribute("data-variant-id");
        const productId = button.getAttribute("data-algolia-object-id");
        // const VariantName = button.getAttribute("data-variant-name");
        const posAttr = button.getAttribute("data-algolia-position");
        const position = posAttr && !isNaN(posAttr) ? parseInt(posAttr) : undefined;
        const productTitle = button.getAttribute("data-product-title");
        
        console.log("🛒 Add to Cart tracked for:", objectID, "at position:", position, "with queryID:", queryID);
 
        const payload = {
          index: 'shopify_products',
          eventName: 'Added to cart from direct collection page button',
          objectIDs: [objectID],
          productTitle: productId,
          ID: productId,
          // VariantName: VariantName
        };
 
        if (queryID && position !== undefined) {
          payload.positions = [position];
        }
 
        aa('convertedObjectIDsAfterSearch', payload);
      });
    }
      }, 2000); // 300ms delay to allow Algolia to render results
});
